import type { FC } from "react";
import type { Organization } from "../../../../../types/admin";

interface OrganizationInfoProps {
  organization: Organization;
}

export const OrganizationInfo: FC<OrganizationInfoProps> = ({
  organization,
}) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString("ja-JP", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const infoItems = [
    {
      label: "組織ID",
      value: organization.id,
      type: "text" as const,
    },
    {
      label: "組織名",
      value: organization.name,
      type: "text" as const,
    },
    {
      label: "説明",
      value: organization.description || "設定されていません",
      type: "text" as const,
    },
    {
      label: "ステータス",
      value: organization.isActive,
      type: "status" as const,
    },
    {
      label: "所属従業員数",
      value: organization.employeeCount || 0,
      type: "number" as const,
    },
    {
      label: "作成日時",
      value: organization.createdAt,
      type: "date" as const,
    },
    {
      label: "更新日時",
      value: organization.updatedAt,
      type: "date" as const,
    },
  ];

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="px-6 py-4 border-b border-gray-200">
        <h3 className="text-lg font-medium text-gray-900">組織情報</h3>
      </div>

      <div className="px-6 py-4">
        <dl className="space-y-4">
          {infoItems.map(item => (
            <div key={item.label}>
              <dt className="text-sm font-medium text-gray-500 mb-1">
                {item.label}
              </dt>
              <dd className="text-sm text-gray-900">
                {item.type === "status" ? (
                  <span
                    className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                      item.value
                        ? "bg-green-100 text-green-800"
                        : "bg-red-100 text-red-800"
                    }`}
                  >
                    {item.value ? "アクティブ" : "非アクティブ"}
                  </span>
                ) : item.type === "date" ? (
                  <span className="text-gray-700">
                    {formatDate(item.value as string)}
                  </span>
                ) : item.type === "number" ? (
                  <span className="font-medium text-blue-600">
                    {(item.value as number).toLocaleString()}
                  </span>
                ) : (
                  <span className="break-all">{item.value as string}</span>
                )}
              </dd>
            </div>
          ))}
        </dl>
      </div>

      {/* アクション統計 */}
      <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
        <h4 className="text-sm font-medium text-gray-900 mb-3">統計情報</h4>
        <div className="grid grid-cols-2 gap-4">
          <div className="text-center">
            <div className="text-lg font-bold text-blue-600">
              {organization.employeeCount || 0}
            </div>
            <div className="text-xs text-gray-500">従業員数</div>
          </div>
          <div className="text-center">
            <div className="text-lg font-bold text-green-600">
              {organization.isActive ? "稼働中" : "停止中"}
            </div>
            <div className="text-xs text-gray-500">稼働状況</div>
          </div>
        </div>
      </div>
    </div>
  );
};
